import { Box, Card, CardActionArea, CardContent, CardMedia, Typography } from '@mui/material';
import { makeStyles, useTheme } from '@mui/styles';
import React from 'react';

import ImageKit from 'components/common/Image';
import { ChipKit } from 'components/kit/Chip';
import { getOldBaseURL } from 'utility/baseURL';

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		// height: '21.5rem',
		// maxHeight: '21.5rem',
		background: theme.palette.background.light,
		borderRadius: theme.shape.medium,
		boxShadow: theme.shadows[1],
		padding: '0.4rem',
		position: 'relative',
	},
	banner: {
		width: '100%',
		height: '7.2rem',
		position: 'relative',
		top: '0',
		display: 'flex',
		justifyContent: 'flex-end',
		alignItems: 'center',
		flexDirection: 'column',
	},
	boxBanner: {
		width: '100%',
		height: '7.2rem',
		borderRadius: `1.2rem 1.2rem 0 0 `,
	},
	bannerImage: {
		borderRadius: `1.2rem 1.2rem 0 0 `,
		background: ` linear-gradient(180deg, rgba(0, 0, 0, 0.16) 0%, rgba(0, 0, 0, 0.32) 100%) !important`,
	},
	bannerComingSoon: {
		width: '100%',
		height: '10.4rem',
		borderRadius: `1.2rem 1.2rem 0 0 `,
		background: `linear-gradient(208.28deg, rgba(0, 0, 0, 0.88) -5.85%, rgba(0, 0, 0, 0.72) 107.56%)`,
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		display: 'flex',
	},
	advertising: {
		zIndex: 1,
		position: 'absolute',
		left: '1.2rem',
		top: '1.2rem',
	},
	logoBox: {
		width: '8.8rem',
		height: '8.8rem',
		boxShadow: `0px 6px 25px -6px rgba(0, 0, 0, 0.18)`,
		borderRadius: theme.shape.medium,
		position: 'absolute',
		background: theme.palette.background.light,
		top: '3rem',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
}));

const SquareStoreItem = (props) => {
	const theme = useTheme();
	const classes = useStyles();
	const baseURL = getOldBaseURL();

	const logo = React.useMemo(() => {
		const findingLogo = props?.Images?.find((img) => img.SupplierImageTypeID === 1)?.FileUrl;

		return baseURL + findingLogo;
	}, [baseURL, props?.Images]);

	const banner = React.useMemo(() => {
		const findingBanner = props?.Images?.find((img) => img.SupplierImageTypeID === 4)?.FileUrl;

		return baseURL + findingBanner;
	}, [baseURL, props?.Images]);
	const tagsStore = props?.Tags?.filter((item) => item.CategoryId !== 111111112);

	return (
		<Card className={classes.root}>
			<CardActionArea>
				<CardMedia className={classes.banner}>
					<Box className={classes.boxBanner}>
						<ImageKit
							src={banner}
							objectFit="cover"
							placeholder="blur"
							className={classes.bannerImage}
							layout="fill"
						/>
					</Box>
					<Box className={classes.logoBox}>
						<Box width={'6rem'} height={'5.8rem'}>
							<ImageKit
								alt={props.alt}
								src={logo}
								placeholder="blur"
								width={'100%'}
								height={'100%'}
								objectFit="cover"
							/>
						</Box>
					</Box>
				</CardMedia>
				<CardContent>
					<Box
						display={'flex'}
						mt="5rem"
						justifyContent="center"
						alignItems={'center'}
						flexDirection="column"
					>
						<Typography
							color={theme.palette.text.dark}
							variant="subtitle1"
							fontWeight={700}
							lineHeight={'2.3rem'}
							minHeight="4.5rem"
							maxHeight="4.5rem"
						>
							{props?.Name || props.SupplierName}
						</Typography>
						{props?.BranchCount > 0 && (
							<Typography
								color={theme.palette.text.secondary}
								style={{ marginRight: '1.2rem' }}
								fontWeight={700}
								variant="subtitle1"
								lineHeight={'2.2rem'}
							>
								+ {props?.BranchCount} شعبه
							</Typography>
						)}
						<Box display="flex" justifyContent={tagsStore?.length >= 2 ? 'space-between' : 'center'}>
							{React.Children.toArray(
								tagsStore?.map((tag) => (
									<Box m="0.5rem 0.2rem">
										<ChipKit
											{...tag}
											colors={tag.Style}
											label={<Typography variant="body2">{(tag?.label || tag?.Text) ?? '-'}</Typography>}
										/>
									</Box>
								)),
							)}
						</Box>
					</Box>
				</CardContent>
			</CardActionArea>
		</Card>
	);
};

SquareStoreItem.defaultProps = {
	advertising: true,
	Images: [],
};

export default SquareStoreItem;
